var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdGuardDns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    width: 80,
    height: 80,
    rx: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.222 12C31.401 12 20.76 14.074 12 18.64c0 9.862-.12 34.429 28.222 51.215C68.566 53.069 68.445 28.502 68.445 18.64c-8.76-4.566-19.4-6.64-28.223-6.64z",
    fill: "#68BC71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.193 69.838C11.88 53.052 12 28.498 12 18.64c8.75-4.56 19.378-6.635 28.193-6.64v57.838z",
    fill: "#67B279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.193 50.603L56.259 27.6c-1.25-1.002-2.347-.295-2.951.253l-.022.002-14.23 14.803-5.362-6.453c-2.557-2.955-6.035-.7-6.847-.105l12.346 14.502",
    fill: "#FFF"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxyZWN0IGZpbGw9IiNGRkYiIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCIgcng9IjIwIi8+PHBhdGggZD0iTTQwLjIyMiAxMkMzMS40MDEgMTIgMjAuNzYgMTQuMDc0IDEyIDE4LjY0YzAgOS44NjItLjEyIDM0LjQyOSAyOC4yMjIgNTEuMjE1QzY4LjU2NiA1My4wNjkgNjguNDQ1IDI4LjUwMiA2OC40NDUgMTguNjRjLTguNzYtNC41NjYtMTkuNC02LjY0LTI4LjIyMy02LjY0eiIgZmlsbD0iIzY4QkM3MSIvPjxwYXRoIGQ9Ik00MC4xOTMgNjkuODM4QzExLjg4IDUzLjA1MiAxMiAyOC40OTggMTIgMTguNjRjOC43NS00LjU2IDE5LjM3OC02LjYzNSAyOC4xOTMtNi42NHY1Ny44Mzh6IiBmaWxsPSIjNjdCMjc5Ii8+PHBhdGggZD0iTTM5LjE5MyA1MC42MDNMNTYuMjU5IDI3LjZjLTEuMjUtMS4wMDItMi4zNDctLjI5NS0yLjk1MS4yNTNsLS4wMjIuMDAyLTE0LjIzIDE0LjgwMy01LjM2Mi02LjQ1M2MtMi41NTctMi45NTUtNi4wMzUtLjctNi44NDctLjEwNWwxMi4zNDYgMTQuNTAyIiBmaWxsPSIjRkZGIi8+PC9nPjwvc3ZnPg==";
export { SvgAdGuardDns as ReactComponent };